import { z } from 'zod';
import { PRODUCT_TYPE_SCHEMA } from '../product-type/product-types';
import { PRICING_STRATEGY_SCHEMA } from '../product-group/product-group-type';

export const BusinessCaseSchema = z.object({
    productType: PRODUCT_TYPE_SCHEMA,
    pricingStrategy: PRICING_STRATEGY_SCHEMA,
    isStandalone: z.boolean(),
});

export type BusinessCase = z.infer<typeof BusinessCaseSchema>;
